import { TranslationMessages } from 'react-admin'
import germanMessages from './ra-language-german'

germanMessages.ra.boolean.null = 'Keine Angabe'

const customGermanMessages: TranslationMessages = {
  ...germanMessages,
  feed: {
    title: 'Portale & Feed',
    intro:
      'Der NautiX-Feed geht täglich an boat24 / Boatvertizer, die ihn auf die Portale verteilen. Hier steht, ob er läuft, welche Boote mitgehen und wann die Portale ihn abholen.',
    url: 'Feed-Adresse',
    copy: 'Adresse kopieren',
    copied: 'Adresse kopiert',
    tiles: {
      feed: 'Feed',
      enabled: 'eingeschaltet',
      disabled: 'ausgeschaltet',
      enabled_sub: 'neu erzeugt nach jeder Änderung',
      disabled_sub: 'es wird nichts veröffentlicht',
      adverts: 'Inserate im Feed',
      adverts_sub: 'veröffentlicht %{when}',
      never: 'noch nie veröffentlicht',
      held_back: 'Zurückgehalten',
      held_back_sub: 'freigegeben, aber unvollständig',
      fetches: 'Abrufe (30 Tage)',
      last_fetch: 'zuletzt %{when}',
      no_fetch: 'noch nie abgerufen',
    },
    generate: 'Feed neu erzeugen',
    generating: 'Feed wird erzeugt …',
    force: 'Trotzdem veröffentlichen',
    force_confirm:
      'Wirklich veröffentlichen? Jedes Inserat, das im neuen Feed fehlt, wird auf allen Portalen beendet.',
    cancel: 'Abbrechen',
    outcome: {
      published: 'Veröffentlicht: %{count} Inserate.',
      rejected: 'Zurückgehalten. %{reason}',
      failed: 'Fehlgeschlagen. %{reason}',
    },
    bv: {
      title: 'Boatvertizer: Aufrufe und Anfragen',
      as_of: 'Stand %{date}',
      hint: 'Zahlen von Boatvertizer für den Zeitraum, den Boatvertizer auswertet, alle Portale zusammen.',
      views: 'Detailaufrufe',
      views_short: 'Aufrufe',
      inquiries: 'Anfragen',
      online: 'Inserate online',
      online_sub: 'laut Boatvertizer',
      chart: 'Detailaufrufe pro Tag, alle Inserate',
      listing: 'Inserat',
      portals: 'Portale',
      ctr: 'Klickrate',
      crm_boat: 'im CMS: %{name}',
      not_matched: 'keinem Boot im CMS zugeordnet',
      empty: 'Noch keine Zahlen von Boatvertizer.',
      gone: '%{smart_count} Inserat aus einem früheren Abruf führt Boatvertizer nicht mehr; es ist ausgeblendet. |||| %{smart_count} Inserate aus früheren Abrufen führt Boatvertizer nicht mehr; sie sind ausgeblendet.',
      account: {
        title: 'Boatvertizer-Zugang',
        intro:
          'Mit diesem Zugang holt das CMS die Zahlen täglich selbst bei Boatvertizer ab. Das Passwort wird verschlüsselt auf dem Server gespeichert und hier nie wieder angezeigt.',
        username: 'Benutzername bei Boatvertizer',
        password: 'Passwort',
        save: 'Speichern und abrufen',
        saved: 'Zugang gespeichert.',
        change: 'Zugang ändern',
        cancel: 'Abbrechen',
        stored: 'Hinterlegt für %{username}, am %{date}.',
        fetch: 'Jetzt abrufen',
        fetching: 'Rufe ab … (dauert etwa eine halbe Minute)',
        never: 'Noch nicht abgerufen.',
        last_ok: 'Zuletzt abgerufen %{when}: %{message}',
        last_failed: 'Abruf %{when} fehlgeschlagen: %{message}',
        daily: 'Täglich automatisch abgerufen.',
      },
    },
    reasons: {
      disabled: 'Der Feed ist ausgeschaltet.',
      settings: 'Die Einstellungen sind unvollständig.',
      shrink: 'Schrumpfschutz: es würden zu viele Inserate wegfallen.',
      invalid: 'Der Feed entspricht nicht dem NautiX-Schema.',
      other: 'Fehler beim Erzeugen.',
    },
    boats: {
      title: 'Boote mit Freigabe',
      empty: 'Noch kein Boot ist für die Portale freigegeben (Boot bearbeiten → „Portale“).',
      boat: 'Boot',
      state: 'Stand',
      in_feed: 'im Feed',
      held: 'zurückgehalten',
      missing: 'fehlt: %{fields}',
      unpublished:
        '%{smart_count} weiteres Boot ist nicht freigegeben. |||| %{smart_count} weitere Boote sind nicht freigegeben.',
    },
    runs: {
      title: 'Letzte Läufe',
      when: 'Zeit',
      result: 'Ergebnis',
      adverts: 'Inserate',
      message: 'Meldung',
      published: 'veröffentlicht',
      rejected: 'zurückgehalten',
      failed: 'fehlgeschlagen',
      empty: 'Noch kein Lauf.',
      summary_adverts: '%{smart_count} Inserat |||| %{smart_count} Inserate',
      summary_skipped: '%{smart_count} zurückgehalten',
      summary_warnings: '%{smart_count} Hinweis |||| %{smart_count} Hinweise',
    },
    fetches: {
      title: 'Abrufe',
      hint: 'Jede Anfrage an die Feed-Adresse. boat24 holt einmal am Tag ab, sobald die Adresse dort eingetragen ist.',
      when: 'Zeit',
      client: 'Abrufer',
      result: 'Ergebnis',
      size: 'Größe',
      empty: 'Noch keine Abrufe.',
      status_200: 'neue Fassung',
      status_304: 'unverändert',
      status_404: 'kein Feed',
    },
    settings: {
      title: 'Einstellungen',
      edit: 'Bearbeiten',
      save: 'Speichern',
      saved: 'Einstellungen gespeichert.',
      incomplete: 'Für den Feed fehlen noch: %{fields}.',
      feed_enabled: 'Feed eingeschaltet',
      feed_enabled_hint:
        'Aus: es wird nichts veröffentlicht, die Portale behalten die letzte Fassung.',
      account_name: 'Händlername',
      office_name: 'Büro',
      office_address: 'Straße',
      office_postcode: 'PLZ',
      office_town: 'Ort',
      office_country: 'Land (ISO, z. B. DE)',
      office_email: 'E-Mail',
      office_phone: 'Telefon',
      strip_contact_details: 'Kontaktdaten aus den Beschreibungen entfernen',
      strip_contact_details_hint:
        'Viele Portale verbieten Telefonnummern und Adressen im Beschreibungstext.',
      shrink_guard_percent: 'Schrumpfschutz (%)',
      shrink_guard_percent_hint:
        'Fallen mehr Inserate weg, wird nicht veröffentlicht: ein fehlendes Inserat wird auf allen Portalen beendet.',
    },
  },
  auth: {
    mfa: {
      title: 'Zwei-Faktor-Anmeldung',
      code: 'Code aus der Authenticator-App',
      hint: '6 Ziffern, alle 30 Sekunden neu',
      confirm: 'Bestätigen',
      back: 'Zurück zur Anmeldung',
      invalid: 'Der Code stimmt nicht – bitte den aktuellen Code aus der App eingeben.',
    },
  },
  account: {
    title: 'Mein Konto',
    calendar: {
      title: 'Kalender auf Handy und Computer',
      intro:
        'Das CMS lässt sich als Kalender-Account einrichten – auf iPhone, iPad und Mac direkt, auf Android mit der App DAVx⁵, in Thunderbird und in Outlook mit einem Zusatzprogramm. Es gibt zwei Kalender: „Yachthandel24“ mit den eigenen Terminen (bei denen man unter „Zuständig“ steht) und „Yachthandel24 – Team“ mit denen der Kollegen, nur zum Lesen. Die Anmeldung läuft mit einem eigenen Kalender-Passwort, nicht mit dem CMS-Passwort.',
      setup: 'Kalender einrichten',
      issued:
        'Diese Angaben im Kalender auf dem Gerät eintragen. Das Passwort wird nur jetzt angezeigt; wer es verliert, erzeugt einfach ein neues.',
      server: 'Server',
      url: 'Adresse (wenn nach URL gefragt)',
      username: 'Benutzername',
      password: 'Passwort',
      copy: 'Kopieren',
      done: 'Fertig, ist eingetragen',
      used: 'Zuletzt abgeglichen: %{when} (%{client})',
      unused: 'Eingerichtet, aber noch von keinem Gerät abgeglichen.',
      writable: 'Änderungen vom Gerät übernehmen',
      writable_on:
        'In beide Richtungen: Eigene Termine lassen sich auf dem Gerät anlegen, verschieben und löschen; das CMS übernimmt es.',
      writable_off: 'Nur lesen: Das Gerät zeigt die Termine, Änderungen dort kommen nicht ins CMS.',
      show_team: 'Termine der Kollegen anzeigen',
      show_team_hint: 'Als zweiter Kalender „Yachthandel24 – Team“, nur zum Lesen.',
      saved: 'Gespeichert. Das Gerät übernimmt es beim nächsten Abgleich.',
      new_password: 'Neues Passwort',
      new_password_title: 'Neues Kalender-Passwort erzeugen?',
      new_password_hint:
        'Das bisherige Passwort hört sofort auf zu gelten. Auf jedem Gerät muss danach das neue eingetragen werden.',
      remove: 'Ausschalten',
      remove_title: 'Kalender-Abgleich ausschalten?',
      remove_hint:
        'Kein Gerät kann sich danach mehr anmelden. Der Account auf dem Gerät kann gelöscht werden; die Termine im CMS bleiben.',
      removed: 'Kalender-Abgleich ausgeschaltet.',
      howto: 'So geht es auf den einzelnen Geräten',
      devices: {
        iphone: {
          name: 'iPhone und iPad',
          steps:
            'Einstellungen → Apps → Kalender → Kalenderaccounts → Account hinzufügen → Andere → CalDAV-Account hinzufügen. Server: %{server}, dazu Benutzername und Passwort von oben.',
        },
        mac: {
          name: 'Mac',
          steps:
            'Kalender → Einstellungen → Accounts → + → Anderer CalDAV-Account. Accounttyp „Manuell“, Benutzername und Passwort von oben, Serveradresse: %{url}',
        },
        android: {
          name: 'Android',
          steps:
            'Die App DAVx⁵ installieren (Play Store oder F-Droid) → Konto hinzufügen → „Mit URL und Benutzername anmelden“. Basis-URL: %{url}, dazu Benutzername und Passwort. Die Kalender erscheinen dann in der Kalender-App.',
        },
        thunderbird: {
          name: 'Thunderbird',
          steps:
            'Kalender → Neuer Kalender → Im Netzwerk. Benutzername von oben, Adresse: %{url}. Thunderbird fragt dann nach dem Passwort.',
        },
        outlook: {
          name: 'Outlook (Windows)',
          steps:
            'Outlook kann CalDAV nicht selbst. Mit dem kostenlosen Zusatzprogramm „CalDav Synchronizer“ geht es: neues Profil, Adresse %{url}, Benutzername und Passwort von oben.',
        },
      },
    },
    mfa: {
      title: 'Zwei-Faktor-Anmeldung',
      intro:
        'Zusätzlich zum Passwort fragt die Anmeldung nach einem Code aus einer Authenticator-App auf dem Handy, zum Beispiel Google Authenticator, Microsoft Authenticator oder Apple Passwörter. Ein erratenes Passwort allein reicht dann nicht mehr.',
      on: 'Eingeschaltet: Bei jeder Anmeldung wird nach dem Code gefragt.',
      off: 'Ausgeschaltet.',
      setup: 'Einrichten',
      scan: 'Den QR-Code mit der Authenticator-App scannen – oder den Schlüssel von Hand eintragen. Dann den angezeigten Code hier eingeben.',
      qr: 'QR-Code für die Authenticator-App',
      code: 'Code aus der App',
      activate: 'Einschalten',
      activated: 'Zwei-Faktor-Anmeldung eingeschaltet.',
      disable: 'Ausschalten',
      disable_title: 'Zwei-Faktor-Anmeldung ausschalten?',
      disable_hint: 'Zur Bestätigung den aktuellen Code aus der App eingeben.',
      disabled: 'Zwei-Faktor-Anmeldung ausgeschaltet.',
      locked: 'Für Administratoren vorgeschrieben – Ausschalten ist nicht möglich.',
      invalid: 'Der Code stimmt nicht – bitte den aktuellen Code eingeben.',
      required_title: 'Bitte Zwei-Faktor-Anmeldung einrichten',
      required:
        'Für Administratoren ist die Zwei-Faktor-Anmeldung vorgeschrieben. Nach dem Einrichten geht es direkt weiter.',
      team: 'Im Team',
      status_on: 'eingerichtet',
      status_off: 'nicht eingerichtet',
      reset: 'Zurücksetzen',
      reset_title: 'Zwei-Faktor-Anmeldung für %{name} zurücksetzen?',
      reset_hint:
        'Zum Beispiel nach einem Handyverlust: %{name} meldet sich danach nur mit dem Passwort an und richtet die Zwei-Faktor-Anmeldung neu ein.',
      reset_done: 'Zwei-Faktor-Anmeldung für %{name} zurückgesetzt.',
      require: 'Für alle Administratoren vorschreiben',
      require_hint:
        'Wer sie noch nicht eingerichtet hat, wird bei der nächsten Anmeldung dazu aufgefordert.',
      require_own_first: 'Zuerst für das eigene Konto einrichten.',
    },
  },
  error_page: {
    details: 'Technische Details',
  },
  catalog: {
    title: 'Gebrauchtyachtkatalog',
    intro:
      'Eine neue Ausgabe hier hochladen, so wie sie aus dem Layout kommt. Das CMS macht daraus die Fassung für die Website (eine viel kleinere PDF) und das Titelbild; die Website zeigt die neue Ausgabe innerhalb von 15 Minuten von selbst.',
    current: 'Auf der Website',
    none: 'Noch keine Ausgabe hochgeladen – die Website zeigt bis dahin den Katalog, der dort liegt.',
    issue: 'Ausgabe %{issue}',
    cover: 'Titelbild der Ausgabe %{issue}',
    since: 'seit %{date}',
    pages: '%{pages} Seiten',
    web_pdf: 'Website-PDF',
    original: 'Original',
    new: 'Neue Ausgabe',
    drop: 'PDF hierher ziehen oder klicken',
    not_pdf: 'Bitte eine PDF-Datei wählen.',
    issue_number: 'Ausgabe',
    replaces: 'Ausgabe %{issue} gibt es schon – sie wird ersetzt.',
    publish: 'Hochladen und veröffentlichen',
    uploading: 'Wird hochgeladen … (%{size}, je nach Verbindung ein bis zwei Minuten)',
    processing: 'Wird für die Website verkleinert … (etwa eine Minute)',
    published:
      'Ausgabe %{issue} ist veröffentlicht: %{original} → %{web}, %{pages} Seiten. Die Website zeigt sie innerhalb von 15 Minuten.',
    all: 'Alle Ausgaben',
    published_on: 'Veröffentlicht',
    pages_column: 'Seiten',
  },
  social: {
    title: 'Social Media',
    intro:
      'Ein fertiger Beitrag für Instagram & Co.: bis zu zehn Bilder im passenden Format, das erste mit Name, Eckdaten und Preis, dazu der Text. Herunterladen, auf dem Handy teilen oder direkt auf Instagram veröffentlichen.',
    boat: 'Boot',
    occasion: 'Anlass',
    occasions: {
      new: 'Neu im Bestand',
      price: 'Preis reduziert',
      sold: 'Verkauft',
      none: 'ohne Anlass',
    },
    format: 'Format',
    formats: {
      post: 'Beitrag 4:5',
      square: 'Quadrat',
      story: 'Story 9:16',
    },
    choose_boat: 'Zuerst ein Boot wählen.',
    no_photos: 'Dieses Boot hat noch keine Fotos. Unter „Bilder aufbereiten“ welche hinzufügen.',
    photos: 'Bilder (%{count} von höchstens %{max})',
    photos_hint:
      'Anklicken zum Aus- oder Abwählen; die Reihenfolge der Auswahl ist die Reihenfolge im Beitrag.',
    logo_on_all: 'Logo auf allen Bildern',
    logo_hint: 'Fotos aus „Bilder aufbereiten“ haben ihr Logo schon und bekommen kein zweites.',
    preview: 'Vorschau',
    download: 'Als ZIP herunterladen',
    share: 'Teilen',
    downloaded:
      '%{smart_count} Bild mit Text heruntergeladen. |||| %{smart_count} Bilder mit Text heruntergeladen.',
    caption: 'Text',
    caption_hint: '%{count} von 2.200 Zeichen',
    copy: 'Text kopieren',
    copied: 'Text kopiert.',
    copy_failed: 'Kopieren nicht möglich – bitte den Text markieren und kopieren.',
    how_to: 'In Instagram: neuer Beitrag → Bilder in dieser Reihenfolge wählen → Text einfügen.',
    publish: 'Auf Instagram veröffentlichen',
    connect_first: 'Instagram verbinden',
    confirm_title: 'Auf Instagram veröffentlichen?',
    confirm_feed:
      '%{smart_count} Bild als Beitrag auf @%{username}, mit dem Text daneben. |||| %{smart_count} Bilder als ein Beitrag auf @%{username}, mit dem Text daneben.',
    confirm_story:
      '%{smart_count} Bild als Story auf @%{username}. Storys haben keinen Text. |||| %{smart_count} Bilder als Storys auf @%{username}, eine nach der anderen. Storys haben keinen Text.',
    confirm_go: 'Veröffentlichen',
    cancel: 'Abbrechen',
    uploading: 'Bilder werden hochgeladen …',
    publishing: 'Instagram übernimmt die Bilder … (dauert etwa eine Minute)',
    published: 'Auf Instagram veröffentlicht: %{message}.',
    view_post: 'Ansehen',
    instagram: {
      title: 'Instagram-Konto',
      intro:
        'Mit einem verbundenen Konto veröffentlicht das CMS Beiträge und Storys direkt. Die Anmeldung läuft bei Instagram selbst; Ihr Instagram-Passwort sieht das CMS nie.',
      setup: 'Einmalig einzurichten:',
      step_account:
        'Das Instagram-Konto auf ein professionelles Konto umstellen (Business oder Creator) – in der Instagram-App unter Einstellungen → Kontotyp.',
      step_app:
        'Auf developers.facebook.com eine App vom Typ „Business“ anlegen und das Produkt „Instagram“ hinzufügen (API-Einrichtung mit Instagram-Login).',
      step_redirect: 'Dort beim Instagram-Business-Login diese Weiterleitungs-URL eintragen:',
      step_tester:
        'Unter App-Rollen das Instagram-Konto als Instagram-Tester hinzufügen und die Einladung in Instagram annehmen.',
      step_keys:
        'Die Instagram-App-ID und den Instagram-App-Geheimschlüssel von dort hier eintragen.',
      app_id: 'Instagram-App-ID',
      app_secret: 'Instagram-App-Geheimschlüssel',
      save: 'Speichern',
      saved: 'App gespeichert. Jetzt mit Instagram verbinden.',
      app_stored: 'App %{app_id} hinterlegt.',
      connect: 'Mit Instagram verbinden',
      change_app: 'App ändern',
      connected:
        'Verbunden mit @%{username} seit %{since}. Der Zugang gilt bis %{until} und wird automatisch verlängert.',
      disconnect: 'Trennen',
      disconnected: 'Instagram-Konto getrennt.',
      refresh_failed: 'Verlängern des Zugangs fehlgeschlagen: %{message}',
      expired: 'Der Zugang zu @%{username} ist abgelaufen – bitte neu verbinden.',
      recent: 'Zuletzt veröffentlicht',
      kinds: { feed: 'Beitrag', story: 'Story' },
      connecting: 'Verbinde mit Instagram …',
      connected_as: 'Verbunden mit @%{username}.',
      denied: 'Instagram hat die Verbindung nicht erlaubt: %{reason}',
      bad_state:
        'Diese Rückmeldung von Instagram gehört nicht zu einer Anmeldung von hier. Bitte noch einmal „Mit Instagram verbinden“.',
      back: 'Zurück zu Social Media',
    },
  },
  photos: {
    title: 'Bilder aufbereiten',
    drop: 'Fotos hierher ziehen oder klicken',
    drop_hint:
      'JPEG, PNG oder WebP, gern viele auf einmal. Jedes Foto wird automatisch korrigiert (Tonwert, Farbstich, dunkle Innenaufnahmen).',
    preparing: 'Fotos werden vorbereitet',
    processing: 'Fotos werden fertiggestellt',
    uploading: 'Fotos werden gespeichert',
    unreadable:
      'Dieses Format kann der Browser nicht lesen (z. B. HEIC vom iPhone) – bitte als JPEG exportieren.',
    sort_hint:
      '%{smart_count} Foto – zum Sortieren ziehen |||| %{smart_count} Fotos – zum Sortieren ziehen',
    show_original: 'Original zeigen',
    move_left: 'Nach vorn',
    move_right: 'Nach hinten',
    rotate: 'Drehen',
    correct: 'Automatische Korrektur',
    remove: 'Entfernen',
    settings: 'Einstellungen',
    size: 'Größe (längste Seite)',
    size_px: '%{size} px',
    size_original: 'Originalgröße',
    enhance: 'Automatische Korrektur',
    sharpen: 'Schärfen',
    sharpen_off: 'aus',
    sharpen_light: 'leicht',
    sharpen_strong: 'stark',
    watermark: 'Logo einfügen',
    logo_choose: 'Anderes Logo …',
    logo_default: 'Standard-Logo',
    position: 'Position',
    positions: {
      'top-right': 'oben rechts',
      'top-left': 'oben links',
      'bottom-right': 'unten rechts',
      'bottom-left': 'unten links',
      center: 'Mitte',
    },
    logo_size: 'Logo-Größe',
    opacity: 'Deckkraft',
    halo: 'Heller Schein hinter dem Logo (für dunkle Fotos)',
    reset: 'Einstellungen zurücksetzen',
    finish: 'Fertigstellen',
    file_prefix: 'Dateiname',
    file_example: 'z. B. %{name}',
    download: 'Als ZIP herunterladen (%{smart_count})',
    downloaded: '%{smart_count} Foto heruntergeladen. |||| %{smart_count} Fotos heruntergeladen.',
    boat: 'Boot',
    save_to_boat: 'Beim Boot speichern (%{smart_count})',
    save_hint:
      'Die Fotos werden in dieser Reihenfolge hinter die vorhandenen Fotos des Boots gehängt – so gehen sie auch an Boatvertizer und auf die Website.',
    saved:
      '%{smart_count} Foto bei %{boat} gespeichert. |||| %{smart_count} Fotos bei %{boat} gespeichert.',
    open_boat: 'Boot öffnen',
    unsaved:
      '%{smart_count} Foto ist noch nicht gespeichert. „Beim Boot speichern“ hängt es an das Boot. |||| %{smart_count} Fotos sind noch nicht gespeichert. „Beim Boot speichern“ hängt sie an das Boot.',
    unsaved_leave:
      'Die vorbereiteten Fotos sind noch nicht beim Boot gespeichert und gehen verloren, wenn Sie die Seite verlassen. Trotzdem verlassen?',
  },
  dashboard: {
    title: 'Dashboard',
    morning: 'Guten Morgen',
    day: 'Guten Tag',
    evening: 'Guten Abend',
    new_boat: 'Neues Boot',
    new_customer: 'Neuer Kunde',
    new_appointment: 'Neuer Termin',
    photos: 'Bilder aufbereiten',
    inventory: 'Bestand',
    no_status: 'ohne Status',
    upcoming: 'Nächste Termine',
    upcoming_none: 'Keine Termine in den nächsten 14 Tagen.',
    all_appointments: 'Alle Termine',
    today: 'heute',
    tomorrow: 'morgen',
    all_day: 'ganztägig',
    in_charge: 'Zuständig: %{names}',
    todo: 'Zu erledigen',
    todo_hint: 'Boote in Bearbeitung und in Vermittlung, denen noch etwas fehlt.',
    todo_none: 'Nichts offen: Alle Boote in Bearbeitung und Vermittlung sind vollständig.',
    todos: {
      no_photos: 'Ohne Fotos (für Portale und Instagram nötig)',
      no_price: 'Ohne Fragpreis',
      no_owner: 'Ohne Eigner',
      below_limit: 'Angebotspreis unter der Preisuntergrenze',
    },
    more: 'und %{count} weitere',
    portals: 'Portale',
    portals_period: 'Boatvertizer, alle Portale zusammen: %{from} bis %{to}',
    inquiries: 'Anfragen',
    views: 'Aufrufe',
    top: 'Am meisten gefragt',
    top_line: '%{inquiries} Anfragen · %{views} Aufrufe',
    portals_none: 'Noch keine Zahlen von Boatvertizer.',
    portals_fetched: 'Zahlen abgerufen am %{when}',
    portals_failed:
      'Der letzte Abruf bei Boatvertizer ist fehlgeschlagen (siehe „Portale & Feed“).',
    to_feed: 'Portale & Feed',
    recent: 'Zuletzt bearbeitet',
    recent_none: 'Noch nichts bearbeitet.',
  },
  filters: {
    active: 'Aktive Filter',
    no_results: 'Keine Treffer.',
    no_results_search: 'Keine Treffer für „%{search}“.',
    filtered_by: 'Es ist gefiltert nach %{filters}.',
    clear: 'Filter aufheben',
  },
  pos: {
    search: 'Suchen',
    configuration: 'Konfiguration',
    language: 'Sprache',
    theme: {
      name: 'Darstellung',
      light: 'Hell',
      dark: 'Dunkel',
      test: 'Test',
    },
    i18n: {
      show: 'Übersetzungen anzeigen',
      hide: 'Übersetzungen ausblenden',
    },
    notes: {
      show: 'Notizen anzeigen',
      hide: 'Notizen ausblenden',
    },
  },
  resources: {
    marketing: {
      menu: 'Vermarktung',
    },
    phones: {
      title: 'Telefone',
    },
    emails: {
      title: 'Emails',
    },
    customer_customer: {
      title: 'Benutzer zu Benutzer Beziehungen',
    },
    administration: {
      menu: 'Administration',
    },
    users: {
      title: 'Benutzer',
      create: 'Benutzer hinzufügen',
      fields: {
        username: 'Benutzername',
        password: 'Passwort',
        id: 'Benutzer ID',
        role: 'Rolle',
        email: 'Email',
        active: 'Aktiviert',
        disabled: 'Gesperrt',
        last_seen: 'Zuletzt aktiv',
        new_password: 'Neues Passwort',
        new_password_hint: 'Leer lassen, um es nicht zu ändern. Meldet den Benutzer überall ab.',
      },
    },
    events: {
      title: 'History',
    },
    suppliers: {
      menu: 'Anbieter-Datenbank',
      name: 'Anbieter |||| Anbieter',
      title: 'Anbieter',
      empty: 'Es gibt noch keine Anbieter.',
      create: 'Neuen Anbieter hinzufügen',
      base: 'Stammdaten',
      fields: {
        id: 'Anbieter-ID',
        name: 'Name der Firma',
        services: 'Services',
        website: 'Website',
        email: 'Email',
        contact: {
          name: 'Contact Name',
          phone: 'Contact Phone',
          email: 'Contact Email',
        },
      },
    },
    customers: {
      menu: 'Kundendatenbank',
      name: 'Kunde |||| Kunden',
      title: 'Kunden',
      empty: 'Es gibt noch keine Kunden.',
      create: 'Neuen Kunden anlegen',
      base: 'Stammdaten',
      fields: {
        id: 'Kunden-ID',
        title: 'Titel',
        firstname: 'Vorname',
        lastname: 'Nachname',
        salutation: 'Anrede',
        role: 'Rolle',
        company: 'Firmenname',
        identity_card_number: 'Personalausweisnummer',
        nationality: 'Nationalität',
        birthday: 'Geburtstag',
        street: 'Straße und Hausnummer',
        postal_code: 'Postleitzahl',
        city: 'Ort',
        country: 'Land',
        phones: 'Telefonnummern',
        emails: 'E-Mails',
        birth_name: 'Geburtsname',
        informal_salutation: 'Du',
        relationships: 'Beziehungen',
      },
      array_fields: {
        phone: 'Nummer',
        email: 'Email',
        type: 'Typ',
      },
      types: {
        relation_to: 'Beziehungen zu',
        relation_from: 'Beziehungen durch',
        seller: 'Verkäufer',
        suitor: 'Interessent',
        buyer: 'Käufer',
        brokered: 'Interessent an Vermittlung',
        boats: 'Boote',
        boat_name: 'Bootsname',
      },
    },
    boats: {
      menu: 'Bootdatenbank',
      name: 'Boot |||| Boote',
      title: 'Boote',
      empty: 'Es gibt noch keine Boote.',
      create: 'Neues Boot anlegen',
      base: 'Grundinformationen',
      attributes: 'Ausstattung',
      empty_attributes: 'Noch keine Ausstattung hinzugefügt',
      guided_input: 'Geführte Eingabe',
      types: {
        customers: 'Kunde',
        customer_name: 'Kunde',
      },
      fields: {
        id: 'Boot-ID',
        manufacturer: 'Hersteller',
        model: 'Modell',
        name: 'Name',
        build_year: 'Baujahr',
        first_launch: 'Erstwasserung',
        status: 'Status',
        asking_price: 'Fragpreis',
        offer_price: 'Angebotspreis',
        offer_price_hint:
          'Wenn gesetzt, steht dieser Preis statt des Fragpreises auf den Social-Media-Bildern und im Text.',
        lower_price_limit: 'Vertragliche Preisuntergrenze',
        summer_storage: 'Sommerlager',
        winter_storage: 'Winterlager',
        panorama_url: '360°-Rundgang (Link)',
        panorama_url_hint:
          'Link zur 360°-Ansicht (z. B. Kuula, Matterport). Geht mit dem Feed an Boatvertizer und erscheint auf der Website als „360° Rundgang“.',
        panorama_url_invalid: 'Bitte einen vollständigen https://-Link angeben.',
        boat_type: 'Bootstyp',
        motorboat_type: 'Motorboot',
        motorboat_planing_type: 'Typ',
        sailboat_type: 'Segelboot',
        sailboat_rigging_type: 'Takelung',
        goods_type: 'Güterart',
        condition: 'Zustand',
        previous_owners: 'Vorbesitzer',
        build_number: 'Baunummer',
        ce_labeling: 'CE-Kennzeichnung',
        hull_material: 'Rumpfmaterial',
        hull_color: 'Rumpffarbe',
        keel_type: 'Kieltyp',
        lake_constance_approval: 'Bodenseezulassung',
        length_total: 'Länge ü.A. (m)',
        length_waterline: 'Länge Wasserline (m)',
        width: 'Breite (m)',
        draft_max: 'Tiefgang max. (m)',
        draft_min: 'Tiefgang min. (m)',
        displacement: 'Verdrängung (kg)',
        ballast: 'Ballast (kg)',
        customer_id: 'Besitzer',
        relationships: 'Beziehungen',
        publish_nautix: 'Auf den Portalen veröffentlichen',
        publish_nautix_hint:
          'Über den NautiX-Feed an boat24 / Boatvertizer und von dort auf die Portale.',
        subtitle: 'Untertitel',
        subtitle_hint: 'Eine Zeile, höchstens 60 Zeichen.',
        translated_marketing_description: 'Beschreibung für die Portale',
        location_town: 'Liegeort',
        location_country: 'Liegeland',
        location_state: 'Region (optional)',
        location_state_hint: 'ISO-Code, z. B. DE-SH. Nur für einige Länder nötig.',
        vat_status: 'Mehrwertsteuer',
        vat_paid_area: 'MwSt. bezahlt in',
        vat_paid_area_hint: 'Ländercode oder EU',
        sale_status: 'Verkaufsstand auf den Portalen',
        sale_status_none: 'zu verkaufen',
        external_reference: 'Referenznummer',
        external_reference_hint: 'Erscheint im Inserat.',
      },
      relationships: {
        type: 'Typ',
      },
      sections: {
        price: 'Preis',
        storage: 'Lagerung',
        boat_type: 'Boot Typ',
        condition: 'Konditionen',
        materials: 'Materialien',
        certificates: 'Zertifikate',
        dimensions: 'Dimensionen',
        media: 'Medien',
        portals: 'Portale',
      },
      panorama: {
        title: '360°',
        empty:
          'Für dieses Boot ist kein 360°-Rundgang hinterlegt. Den Link unter Bearbeiten → Medien eintragen.',
        open: 'In neuem Fenster öffnen',
      },
      nautix: {
        ready: 'Bereit für die Portale.',
        missing: 'Für die Portale fehlt noch: %{fields}.',
        not_published: 'Nicht freigegeben: das Boot erscheint auf keinem Portal.',
        required: {
          boat_type: 'Bootstyp',
          model: 'Modell',
          price: 'Fragpreis',
          location_country: 'Liegeland',
        },
      },
      choices: {
        vat_status: {
          paid: 'bezahlt',
          'not-paid': 'nicht bezahlt',
          unknown: 'unbekannt',
        },
        sale_status: {
          'under-offer': 'reserviert',
          sold: 'verkauft',
        },
        status: {
          processing: 'in Bearbeitung',
          mediation: 'in Vermittlung',
          handover: 'Verkauft in Übergabe',
          settlement: 'Verkauft in Abwicklung',
          completed: 'Verkauf abgeschloßen',
          cancelled: 'Maklervertrag gekündigt',
        },
        type: {
          sailboat: 'Segelyacht',
          motorboat: 'Motoryacht',
        },
        motorboat_type: {
          cabin_cruiser: 'Cabincruiser',
          fishing_boat: 'Angelboot',
          catamaran: 'Katamaran',
          hovercraft: 'Luftkissen (Hovercraft)',
          houseboat: 'Hausboot',
        },
        motorboat_plan: {
          glider: 'Gleiter',
          'semi-glider': 'Halbgleiter',
          displacer: 'Verdränger',
        },
        sailboat_type: {
          center_cockpit: 'Zentrales Cockpit',
          daysailer: 'Daysailer',
          decksalon: 'Deckssalon',
          dinghy: 'Jolle',
          catamaran: 'Katamaran',
          trimaran: 'Trimaran',
          classic: 'Klassiker',
          motor_sailer: 'Motorsegler',
          flatboat: 'Plattbodenschiff',
        },

        sailboat_rigging: {
          kat: 'Kat',
          sloop: 'Sloop',
          schooner: 'Schoner',
          ketch: 'Ketsch',
          yawl: 'Yawl',
          gaff: 'Gaffel',
          cutter: 'Kutter',
        },

        usedboat: {
          used: 'Gebrauchtboot',
          new: 'Neuboot',
          display: 'Vorführmodell',
        },

        boat_condition: {
          tinkerware: 'Bastlerboot',
          casco: 'Kasko',
          used: 'gebraucht',
          good: 'gut',
          very_good: 'sehr gut',
          like_new: 'neuwertig',
          new: 'neu',
        },
        boat_labels: {
          a: 'A - Hochsee',
          b: 'B - Außerhalb von Küstengewässern',
          c: 'C - Küstennahe Gewässer',
          d: 'D - Geschützte Gewässer',
        },
      },
    },
    sections: {
      title: 'Bereiche',
      name: 'Bereich |||| Bereiche',
      add: 'Bereich hinzufügen',
      fields: {
        slug: 'Eindeutiger Name',
        name: 'Name',
        position: 'Position',
        category_count: '# Kategorien',
      },
    },
    categories: {
      title: 'Ausstattung',
      name: 'Kategorie |||| Kategorien',
      add: 'Ausstattung hinzufügen',
      empty: 'Es gibt noch keine Ausstattung.',
      create: 'Neue Ausstattung anlegen',
      notes: 'Notizen',
      notes_icon: 'Eingabestatus',
      fields: {
        id: 'Kategorie-ID',
        name: 'Name',
        section: 'Bereich',
        description: 'Beschreibung',
        attributes: 'Mögliche Attribute',
        attribute_count: '# Attribute',
      },
    },
    attributes: {
      title: 'Ausstattungsteile',
      save_first: '» Neu hinzugefügte Option zuerst speichern «',
      hint_switching_input_type:
        'Hinweis: Das Attribut "%{attribute}" ist bereits in Verwendung, eine Änderung des Eingabetyps könnte zu Problem führen.',
      fields: {
        id: 'Attribut-ID',
        name: 'Name',
        description: 'Beschreibung',
        default_value: 'Standardwert',
        suffix: 'Suffix',
        unit: 'Einheit',
        input_type: 'Eingabetyp',
        show_by_default: 'Immer anzeigen',
        hidden: 'versteckt',
        choices: 'Auswahl',
        selection: 'Auswahliste',
      },
      types: {
        text: 'Text',
        autocomplete: 'Autovervollst.',
        numeric: 'Zahl',
        boolean: 'Ja / Nein',
        dropdown: 'Liste',
        shared_dropdown: 'Geteilte Liste',
      },
    },
    selections: {
      title: 'Auswahllisten',
      add: 'Auswahlliste hinzufügen',
      empty: 'Es gibt noch keine Auswahlliste.',
      create: 'Neue Auswahlliste anlegen',
      fields: {
        id: 'Listen-ID',
        name: 'Name (Intern)',
        section: 'Bereich',
        context: 'Kontext',
        predefined: 'vorgegeben',
        choices: 'Auswahlmöglichkeiten',
        choice_count: '# Auswahlmöglichkeiten',
      },
      contexts: {
        attributes: {
          choices: 'Austattungs-Attribute',
        },
      },
    },
    choices: {
      create: 'Neue Auswahlmöglichkeit',
      create_item: '"%{item}" hinzufügen',
      fields: {
        key: 'Eindeutiger Name',
        name: 'Name',
      },
    },
    comments: {
      name: 'Kommentar |||| Kommentare',
      empty: 'Noch keine Komentare.',
      title: 'Kommentare',
      create: 'Kommentieren',
      update: 'Ändern',
      remove: 'Entfernen',
      loading: 'Kommentare werden geladen...',
      fields: {
        created_at: 'Erstellt',
        updated_at: 'Geändert',
        comment: 'Kommentar',
        type: 'Typ',
        linked_type: 'Verknüpfung zu',
      },
      linked_types: {
        boats: 'Boot',
        customers: 'Kunde',
      },
    },
    attachments: {
      name: 'Anhang |||| Anhänge',
      empty: 'Noch keine Anhänge.',
      title: 'Anhänge',
      create: 'Anhang erstellen',
      upload: 'Hochladen',
      uploaded: 'Anhang wurde hochgeladen.',
      deleted: 'Anhang wurde gelöscht.',
      loading: 'Anhange werden geladen...',
      fields: {
        type: 'Typ',
        caption: 'Untertitel',
      },
    },
    appointments: {
      name: 'Termin |||| Termine',
      menu: 'Terminverwaltung',
      title: 'Termine',
      create: 'Neuen Termin anlegen',
      empty: 'Es gibt noch keine Termine.',
      calendar_view: 'Kalenderansicht',
      list_view: 'Listenansicht',
      new: 'Neu',
      fields: {
        title: 'Titel',
        start: 'Start',
        end: 'Ende',
        type: 'Typ',
        appointment_customer: 'Kunden',
        appointment_boat: 'Boote',
        appointment_user: 'Zuständig',
        appointment_user_hint:
          'Erscheint im eigenen Kalender dieser Personen (Kalender-Abgleich unter „Mein Konto“).',
        allDay: 'ganztägig',
        location: 'Ort',
        notes: 'Notizen',
      },
      types: {
        none: 'Keinen (Sonstiges)',
        viewing: 'Besichtigung',
        handover: 'Übergabe',
        pickup: 'Abholung',
      },
    },
    documents: {
      name: 'Dokument |||| Dokumente',
      menu: 'Dokumentenverwaltung',
      title: 'Dokumente',
      create: 'Neues Dokument anlegen',
      empty: 'Es gibt noch keine Dokumente.',
      new: 'Neu',
      pdf_preview: 'PDF-Vorschau',
      fields: {
        title: 'Titel',
        type: 'Typ',
        document_customer: 'Kunde(n)',
        document_boat: 'Boot(e)',
        notes: 'Notizen',
      },
      types: {
        none: 'Keinen (Sonstiges)',
        brokerage_agreement: 'Maklervertrag',
      },
      brokerage_agreement: {
        fields: {
          customer_names: 'Kundenname(n)',
          customer_street: 'Straße/Hausnr.',
          customer_postcity: 'Postleitzahl/Ort',
          customer_phone: 'Telefon privat/mobil',
          customer_email: 'E-Mail Adresse',
          start_date: 'Zur verfügung gestellt ab',
          boat_name: 'Bootsname',
          boat_manufacturer: 'Hersteller',
          boat_model: 'Typ',
          boat_weight: 'Gewicht',
          boat_registry: 'registriert bei/unter',
          boat_build_year: 'Baujahr',
          boat_build_number: 'Baunummer',
          boat_length_total: 'Länge ü.A. (m)',
          boat_width: 'Breite (m)',
          boat_draft: 'Tiefgang (m)',
          motor_manufacturer: 'Motorhersteller',
          motor_type: 'Motortyp',
          motor_number: 'Motornummer',
          motor_build_year: 'Baujahr Motor',
          operating_hours: 'Betriebsstunden',
          other: 'Sonstiges',
        },
      },
    },
    relations: {
      add: 'Relation hinzufügen',
      types: {
        seller: 'Verkäufer',
        suitor: 'Interessenten',
        buyer: 'Käufer',
        brokered: 'Vermittlungen',
      },
    },
    history: {
      title: 'Geschichte',
      fields: {
        relation: 'Relation',
        operation: 'Aktion',
        time: 'Zeit',
      },
      operations: {
        INSERT: 'Hinzufügung',
        DELETE: 'Löschung',
        UPDATE: 'Änderung',
      },
    },
    history_transactions: {
      name: 'Geschichte',
      title: 'Geschichte',
    },
  },
  general: {},
  validation: {
    phone: 'Nur Ziffern, Leerzeichen und + ( ) - / .',
    startEnd: 'Muss hinter Start liegen',
  },
  history: {
    modified_by: 'Geändert von',
    last_modified: 'Letzte Änderung',
  },
}

export default customGermanMessages
